<template>
  <router-link :to="{ name: 'Studio', params: { slug: string_to_slug(uni.name), id:uni.id, studio:uni.name, homepage:uni.homepage }}" @click.native="goPage(uni)" class="info-card">
    <div class="info-card__top">
      <img :src="'http://image.tmdb.org/t/p/w185/' + uni.logo_path" alt="studio movies" class="info-card__logo">
      <h3 class="info-card__name">{{ uni.name }}</h3>
      <!-- <h3 class="info-card__name">{{ uni.headquarters }}</h3> -->
    </div>
    <!--<div class="info-card__bottom">-->
      <!--<div class="info-card__title">Kayıtlı Öğrenci Yurdu</div>-->
      <!--<div class="info-card__count">{{ uni.dorms[0].aggregate }}</div>-->
    <!--</div>-->
  </router-link>

</template>

<script>
export default {
  name: 'UniCard',
  props: {
    uni: Object
  },
  methods: {
    goPage(uni) {
     window.localStorage.setItem('faculty_id', '')
     window.localStorage.setItem('faculty_name', '')
     window.localStorage.setItem('studio', this.uni.name)
     window.localStorage.setItem('studioId', this.uni.id)
     window.localStorage.setItem('logo_path', this.uni.logo_path)
     window.localStorage.setItem('description', this.uni.description)
     // let route = { name: 'University', params: { slug: uni.slug }}
     // this.$router.push(route)      
    },
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },     
  }  
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/info-card";
</style>
